import { Response } from 'shared/models/general.ts'

import { clientApi } from './clientApi'

export interface ICalendarPriceResponse {
  price: number
  dep_date: string
  back_date: string
  is_cheapest: boolean
  color?: string
}

export interface ICalendarPrice {
  from_: string | undefined
  to: string | undefined
  date_?: string
  back_date?: string
}

export const CalendarApi = {
  getCalendarPrice(data: ICalendarPrice) {
    return clientApi.get<Response<ICalendarPriceResponse[]>>(
      `/flights/calendar-price`,
      { params: { ...data } },
    )
  },
}
